/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|components|categorymodal'] = {
                c: () => require('partner/components/categorymodal.component.tsx'),
                cn: '__local__-__local__-categorymodal'
            };
componentDictionary['__local__|__local__|components|collectionitem'] = {
                c: () => require('partner/components/collectionitem.component.tsx'),
                cn: '__local__-__local__-collectionitem'
            };
componentDictionary['__local__|__local__|components|curriculamodal'] = {
                c: () => require('partner/components/curriculamodal.component.tsx'),
                cn: '__local__-__local__-curriculamodal'
            };
componentDictionary['__local__|__local__|components|engagemodal'] = {
                c: () => require('partner/components/engagemodal.component.tsx'),
                cn: '__local__-__local__-engagemodal'
            };
componentDictionary['__local__|__local__|components|sequenceproductitem'] = {
                c: () => require('partner/components/sequenceproductitem.component.tsx'),
                cn: '__local__-__local__-sequenceproductitem'
            };
componentDictionary['__local__|__local__|components|signinbutton'] = {
                c: () => require('partner/components/signinbutton.component.tsx'),
                cn: '__local__-__local__-signinbutton'
            };
componentDictionary['__local__|__local__|modules|moe-curated-collection|components|product'] = {
                c: () => require('partner/modules/moe-curated-collection/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|addtocart'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|carticon'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|cartlineitem'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|logo'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/logo.component.tsx'),
                cn: '__local__-__local__-logo'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|product'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|promocode'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|moekwrsitetheme|views|components|rating'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/components/rating.component.tsx'),
                cn: '__local__-__local__-rating'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|addtocart'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|carticon'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|cartlineitem'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|logo'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/logo.component.tsx'),
                cn: '__local__-__local__-logo'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|product'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|promocode'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|moenzcsitetheme|views|components|rating'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/components/rating.component.tsx'),
                cn: '__local__-__local__-rating'
            };
componentDictionary['__local__|__local__|themes|moeochsitetheme|views|components|product'] = {
                c: () => require('partner/themes/moeochsitetheme/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|addtocart'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/addtocart.component.tsx'),
                cn: '__local__-__local__-addtocart'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|carticon'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|cartlineitem'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|logo'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/logo.component.tsx'),
                cn: '__local__-__local__-logo'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|product'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|promocode'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|moetwksitetheme|views|components|rating'] = {
                c: () => require('partner/themes/moetwksitetheme/views/components/rating.component.tsx'),
                cn: '__local__-__local__-rating'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
            };